const styles = {
  root: {},

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center',
    marginTop: 60
  },

  link: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center',
    cursor: 'pointer',
    color: 'rgba(0,0,0,0.75)'
  },

  moreContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  button: {
    alignSelf: 'center',
    minWidth: 250
  },

  backButton: {
    cursor: 'pointer',
    color: '#122B4F',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 'bold',
    position: 'absolute',
    top: 80,
    left: 20
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/exports/styles.js